import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setSurvey, surveySelector } from "../../../redux/surveySlice";
import { templatesSelector } from "../../../redux/templateSlice";

const SelectTemplate = () => {
  const templates = useSelector(templatesSelector);
  const survey = useSelector(surveySelector);
  const dispatch = useDispatch();
  return (
    <>
      <ul className="templateList mb-3">
        {templates.data &&
          templates.data.map((temp) => (
            <li
              key={temp.id}
              onClick={() => {
                dispatch(setSurvey({ field: "templateId", value: temp.id }));
                dispatch(
                  setSurvey({ field: "templateName", value: temp.name })
                );
              }}
              className={survey.templateId === temp.id ? "active" : ""}
            >
              {temp.name}
            </li>
          ))}
      </ul>
    </>
  );
};

export default SelectTemplate;
